import { IdentityService } from 'api/generated/services/IdentityService';
import { UseMutationOptions, useMutation } from 'react-query';

export type IdentityPasswordResetInput = {
  userCode: string;
  requestBody?: string;
};

export const useIdentityUsersPasswordResetCheckMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof IdentityService.postIdentityUsersPasswordResetCheck>>,
      unknown,
      {
        input: IdentityPasswordResetInput;
      },
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ input: input }) => IdentityService.postIdentityUsersPasswordResetCheck(input.userCode, input.requestBody),
    options
  );
